{
  "hero": {
    "verified": "Verified by DEC",
    "kicker": "Public profile",
    "share": "Share this page"
  },
  "impact": {
    "eyebrow": "Generated impact",
    "title": "Years of clean choices, told in numbers.",
    "lede": "Every kWh produced by DEC plants displaces energy from fossil sources on the Italian grid. Here is what has been avoided since the project started, verified in real time by the DEC platform.",
    "metricLabel": "tCO₂ avoided · total",
    "note": "Computed on the IT grid emission factor (Terna 2025).",
    "flights": {
      "label": "Flights avoided",
      "desc": "London-New York round-trip, economy class."
    },
    "trees": {
      "label": "Annual trees",
      "desc": "Number of mature trees needed to absorb the same CO₂ in one year."
    },
    "households": {
      "label": "Households",
      "desc": "Yearly electricity consumption of an average Italian household."
    }
  },
  "narrative": {
    "eyebrow": "Why we do it"
  },
  "plants": {
    "tag": "The plants",
    "title": "<h2>Every plant is a concrete step toward a renewable future</h2>",
    "description": "We concretely support renewable energy producers, enabling them to build ever more plants. Below is an overview of the plants we have contracted.",
    "producing": "Producing",
    "panels": "Panels",
    "since": "In service"
  },
  "production": {
    "tag": "Production",
    "title": "<h2>Our commitment, in full transparency</h2>",
    "description": "Monitor in real time the amount of energy produced by our plants.",
    "chartTitle": "Energy produced · MWh per month",
    "chartSub": "All plants aggregated · DEC-verified data",
    "peakBadge": "Peak",
    "peak": "Production peak:",
    "ytd": "YTD total ·",
    "produced": "Produced",
    "expected": "Expected"
  },
  "map": {
    "eyebrow": "Geography",
    "title": "Where the energy comes from.",
    "lede": "Approximate location of the plants linked to this profile.",
    "activePlants_one": "{{count}} active plant",
    "activePlants_other": "{{count}} active plants",
    "totalSuffix": "total",
    "legend_one": "Active plant · {{count}}",
    "legend_other": "Active plants · {{count}}"
  },
  "embed": {
    "eyebrow": "Embed widget",
    "title": "Show your impact on your website.",
    "lede": "A compact widget with kWh produced and tCO₂ avoided, refreshed every 24 hours. Copy the snippet below and paste it anywhere on your site.",
    "copy": "Copy",
    "copied": "Copied",
    "metric1": "kWh produced",
    "metric2": "CO₂ avoided · cumulative",
    "syncedAt": "Updated",
    "poweredBy": "Powered by"
  },
  "cta": {
    "text": "Want to power your company with solar?",
    "link": "Discover DEC"
  },
  "bookCta": {
    "tag": "Discover all the benefits",
    "title": "<h2>Want a profile like this for your company?</h2>",
    "description": "Book a free consultation with our experts to receive a tailored analysis on how much you can save with DEC (on your electricity consumption).",
    "button": "Book a meeting",
    "contact": "Or write to"
  },
  "share": {
    "message": "Check this out!",
    "copyLink": "Copy link"
  },
  "mapPopup": {
    "powerRented": "Power rented:",
    "panelsRented": "Panels rented:",
    "unknownPower": "Unknown power"
  }
}
